export default __webpack_public_path__ + "static/7_37-cf02ff0e6bb86c287722b7c71f625d5a.png";